import ConfirmModal from "ui/components/ConfirmModal";
import { Message } from "ui/text/Message";
import styles from "./ConfirmNonZeroBasePriceOptions.module.scss";

export type NonZeroBasePriceOptions = Array<{
  label: string;
  price: string;
}>;

interface ConfirmNonZeroBasePriceOptionsProps {
  name: string;
  mesg: string;
  opts: NonZeroBasePriceOptions;
  onClose: () => any;
  onConfirm: () => any;
}

export function ConfirmNonZeroBasePriceOptions({
  name,
  mesg,
  opts,
  onClose,
  onConfirm,
}: ConfirmNonZeroBasePriceOptionsProps) {
  return (
    <ConfirmModal
      open={opts && opts.length > 0}
      title={name}
      onClose={onClose}
      onConfirm={onConfirm}
      message={
        <>
          <Message messageType="warning">{mesg}</Message>
          <div className={styles.wrapper}>
            {opts.map((x) => (
              <div className={styles.baseOption} key={x.label}>
                <div className={styles.label}>{x.label}</div>
                <div className={styles.price}>{x.price}</div>
              </div>
            ))}
          </div>
        </>
      }
    />
  );
}
